module.exports = __webpack_public_path__ + "nc_static/media/assign.124aad81.svg";